import { render, staticRenderFns } from "./AttachmentGroup.vue?vue&type=template&id=ef4869ac"
import script from "./AttachmentGroup.vue?vue&type=script&lang=js"
export * from "./AttachmentGroup.vue?vue&type=script&lang=js"
import style0 from "./AttachmentGroup.vue?vue&type=style&index=0&id=ef4869ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports